import React from 'react';
import {Header} from './components/Header/Header';
import {Banner} from './components/Banner/Banner';
import {FoodList} from './components/FoodList';
import {CookieConsent} from './components/CookieConsent/CookieConsent';
import {BrowserView, MobileView} from 'react-device-detect';
import './Menu.scss';
import {getAppendedClassWithDevice} from '../../shared/utils/deviceUtils';
import {OpeningHours} from "./components/OpeningHours/OpeningHours";

export const Menu = () => {
    return (
        <div>
            <BrowserView>
                <div className={getAppendedClassWithDevice('header-menu-background-wrapper')}></div>
                <div className="row menu vh-100">
                    <div className="col-3 d-flex vh-100">
                        <Banner/>
                    </div>
                    <div className="col-9 vh-100">
                        <Header/>
                        <FoodList/>
                    </div>
                </div>
                <CookieConsent/>
            </BrowserView>
            <MobileView>
                <Banner isMobile/>
                <Header isMobile/>
                <FoodList isMobile/>
                <Banner isMobile displayAsFooter/>
                <OpeningHours isMobile/>
                <div className={getAppendedClassWithDevice('location-wrapper', true)}>
                    <iframe
                        title="bufet-prestige"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2670.0195121249817!2d17.61600687683989!3d47.99401006114442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476b9d0024f3ccf5%3A0x9693f0191168f5c4!2sBufet%20Prestige!5e0!3m2!1sen!2ssk!4v1750083472548!5m2!1sen!2ssk"
                        width="600" height="150" allowFullScreen loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <CookieConsent isMobile/>
            </MobileView>
        </div>
    );
};
